import axios from "axios";

export const APPOINTMENT_SESSION_DOWNLOAD = "APPOINTMENT_SESSION_DOWNLOAD";
export const APPOINTMENT_SESSION_BASE64 = "APPOINTMENT_SESSION_BASE64";

export const getAppointmentSessionReportBase64 = (turnoSiniestroIds, idArt) => (dispatch) => {
  dispatch({
    type: APPOINTMENT_SESSION_BASE64,
    payload: axios
      .post(
        `report/appointmentSession/base64?idArt=${idArt}`,
        turnoSiniestroIds,
      )
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const downloadAppointmentSessionReport = (turnoSiniestroIds, idArt) => (dispatch) => {
  return dispatch({
    type: APPOINTMENT_SESSION_DOWNLOAD,
    payload: axios
      .post(
        `report/appointmentSession/download?idArt=${idArt}`,
        turnoSiniestroIds,
        {
          responseType: "blob",
        },
      )
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};
